module.exports = __webpack_public_path__ + "img/404.bf795135.png";